import dynamic from 'next/dynamic';
import XboostPC from '@/components/xbooost';
import XboostH5 from '@/componentsH5/xboost';
import { useGlobal } from '@/utils/useGlobal';
import { readySites } from '@/constants';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';

export default function Xboost({ SEO, lang }: any) {
    const { isMobile, useEffect, useRouter } = useGlobal();
    const router = useRouter();
    const LayoutCom = isMobile ? XboostH5 : XboostPC;
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    useEffect(() => {
        if (!readySites.includes(router?.locale)) {
            router?.replace(`${router?.locale}/404`);
        }
    }, [router?.locale]);

    return (
        <PageLayout theme="black">
            <SEO title={lang.seo_title || 'x-boost'} description={lang.seo_desc || 'x-boost'} />
            <SEOlinksA locale={router.locale} list={['us', 'za', 'uk', 'ca', 'au', 'sa', 'kr', 'mx', 'ph']} pathname={'x-boost'} />
            <GtmPageLoad />
            <h1 className="visuallyhidden">EcoFlow x-boost</h1>
            <LayoutCom />
        </PageLayout>
    );
}
